import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  imports: [MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  // state if loggin is in progress
  isLoggingInProgress = true;

  // subscription to user observable
  userSubscription: any;

  constructor(
    public authService: AuthService
  ) {
    // Subscribe to the user observable to update the login state
    this.userSubscription = this.authService.user$.subscribe(user => {
      this.isLoggingInProgress = false
    });
  }

  ngOnDestroy() {
    // Unsubscribe from the user observable to prevent memory leaks
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  async signInWithGoogle() {
    try {
      this.isLoggingInProgress = true; // Set the flag to true when login starts
      await this.authService.signInWithGoogleRedirect();
    } catch (error) {
      console.error('Login failed:', error);
    }
  }

  async signOut() {
    try {
      await this.authService.signOut();
    } catch (error) {
      console.error('Sign out failed:', error);
    }
  }
}
